export default {"src":"/_next/static/media/ondersteuning.050de370.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};